import React, { Component } from "react"

class LeaderBoardAdSlot extends Component {
  componentDidMount() {
    console.log("setting up ads")
    let marketing_consent = window.Cookiebot.consent.marketing

    if (marketing_consent) {
      window.googletag = window.googletag || { cmd: [] }

      window.googletag.cmd.push(function () {
        var mapping = window.googletag
          .sizeMapping()
          .addSize([1024, 0], [[728, 90]])
          .addSize([320, 0], [[320, 50]])
          .addSize([0, 0], [])
          .build()

        var respArticleOneSlot = window.googletag
          .defineSlot(
            "/22630386293/Homepage-Leaderboard",
            [
              [320, 50],
              [728, 90],
            ],
            "div-gpt-ad-1683536114060-0"
          )
          .addService(window.googletag.pubads())

        respArticleOneSlot.defineSizeMapping(mapping)
        window.googletag.pubads().enableSingleRequest()
        window.googletag.pubads().collapseEmptyDivs()
        window.googletag.enableServices()
      })

      window.googletag.cmd.push(function () {
        window.googletag.display("div-gpt-ad-1683536114060-0")
      })
    }
  }
  render() {
    return (
      <div
        id="div-gpt-ad-1683536114060-0"
        style={{ minWidth: 320 + "px", minHheight: 50 + "px" }}
      />
    )
  }
}

export default LeaderBoardAdSlot
